import React, { useContext } from "react";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import {  Modal } from "reactstrap";

const ModalContainer = () => {
  const rootStore = useContext(RootStoreContext);
  const { modal: { open, body, content, size }, closeModal } = rootStore.modalStore;

  return (
    <Modal isOpen={open} content={content} toggle={closeModal} size={size}>
      {body}
    </Modal>
  );
};

export default observer(ModalContainer);
